<template>
  <!-- 带卡片包装 -->
  <div class="ful-card" v-if="!bare">
    <div class="ful-card-header">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#009798" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      <span style="font-size:18px;font-weight:700;color:#304744;font-family:'思源黑体', 'Source Han Sans SC', 'Noto Sans SC', system-ui, sans-serif">配送订单详情</span>
      <button class="ful-tag" @click="$emit('goBack')" style="margin-left:auto;cursor:pointer;border:none">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
        返回
      </button>
    </div>
    <div class="ful-body" style="display:block;padding:24px 32px;text-align:center">
      <slot name="status-content" />
    </div>
  </div>

  <!-- bare 模式：直接渲染状态内容 -->
  <div v-else :class="['ful-status-header', { 'is-paid': isPaid }]">
    <div :class="['ful-status-icon', { 'is-paid': isPaid }]">
      <slot name="status-icon" />
    </div>
    <h2 :class="['ful-status-title', { 'is-paid': isPaid }]">{{ orderStatusText }}</h2>
    <p class="ful-status-desc" v-if="showCountdown">
      请在 {{ countDownHour }}:{{ countDownMinute }}:{{ countDownSecond }} 内完成支付，超时订单将自动关闭。
    </p>
    <p class="ful-status-desc" v-else-if="isPaid">
      配送订单已确认，我们将尽快为您安排药材配送。
    </p>
    <div style="display:flex;justify-content:center;gap:12px;margin-top:4px">
      <button class="ful-status-btn" :disabled="isPaid" @click="$emit('toPayPage')" v-if="showPayBtn">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
        {{ isPaid ? '已完成支付' : '¥ ' + orderInfo.sumPrice + ' 立即支付' }}
      </button>
      <button class="ful-status-btn-refund" v-if="showRefundBtn" @click="$emit('applyRefund')">申请退款</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderHeader',
  props: {
    orderInfo: { type: Object, required: true },
    countDownHour: { type: String, default: '00' },
    countDownMinute: { type: String, default: '00' },
    countDownSecond: { type: String, default: '00' },
    bare: { type: Boolean, default: false }
  },
  computed: {
    orderStatusText() { return this.orderInfo.statusText || '' },
    isPaid() { return this.orderInfo.status != 0 && this.orderInfo.status != 99 },
    showCountdown() { return !this.isPaid && (this.orderInfo.status == 0 || this.orderInfo.status == 99) },
    showPayBtn() { return this.orderInfo.status == 0 || this.orderInfo.status == 99 },
    showRefundBtn() { return this.orderInfo.refundFlag == 'Y' }
  }
}
</script>
